import {Entity} from 'app/core/main.entity';
import {EntityCollection} from '../core/main.entityCollection';
import {EventEmitter} from '@angular/core';
import {isArray} from 'rxjs/internal-compatibility';
import {Exclude, Expose, plainToInstance, Transform, Type} from 'class-transformer';
import {SwitchItem} from './switch.entity';
import {Subscription} from 'rxjs';

export abstract class SwitchCollection extends EntityCollection<SwitchItem> {
  allItem: SwitchItem = null;
  onChange: EventEmitter<unknown> = new EventEmitter();

  constructor(items: (Partial<SwitchItem>)[] = []) {

    items.forEach((item) => {
      if (item.sub) {
        item.sub.unsubscribe();
        item.sub = null;
      }
      // console.log('SUBCOLLECTION', item.subCollection);
      item.subCollection = null;
    });

    super(items as SwitchItem[], SwitchItem);

    this.allItem = this.getById('all');

    this.selectInitialData();
  }

  addItems(items: (Partial<SwitchItem>)[] = [], ignoreEvent = false) {

    const notFoundItems: any[] = items.filter((v) => !this.getById(v.id));

    if (notFoundItems?.length) {
      const newItems: any[] = notFoundItems.map((v) => ({
        id: v.id,
        title: v.title ? v.title : v.text // stupid profile api
      }));

      if (newItems.length) {
        super.addItems(newItems);

        this.selectAllIfNeeded();

        if (!ignoreEvent) {
          this.callOnChange();
        }
      }
    }
  }

  removeItems(ids: (string | number) | (string | number)[]) {
    this.toArray(ids).forEach((id) => {
      this.removeById(id);
    });

    this.selectAllIfNeeded();
    this.callOnChange();
  }

  selectInitialData() {
    this.selectAllIfNeeded();
  }

  public countSelectedItem(): number {
    return this.items.filter((item) => item.selected && !item.disabled && !this.itemIsAll(item)).length;
  }

  public isAllSelected() {
    return this.getAllEnabledItems().length === this.countSelectedItem();
  }

  public getAllEnabledItems(): SwitchItem[] {
    return this.items.filter((item) => !item.disabled && !this.itemIsAll(item));
  }

  public getItemsForSelect(profileFix = false) {

  }

  public setSelectedAll(selected: boolean, ignoreId: number | string = null, ignoreEvent = false) {

  }

  public setAllVisible(visible: boolean = true) {
    this.items.forEach((item) => {
      item.visible = visible;
    });
  }

  public getSelectedId() {
  }

  public makeClone(): any {
  }

  protected itemIsAll(item: SwitchItem) {
    return this.allItem && item.id === this.allItem?.id;
  }

  protected callOnChange() {
    this.onChange.emit();
  }

  protected selectAllIfNeeded() {

  }

  protected toArray(value: ((number | string) | (number | string)[]) = null): (string | number)[] {
    if (![undefined, null].includes(value) && !isArray(value)) {
      return [value];
    }

    return value as (number | string)[];
  }
}

export class SwitchRadioCollection extends SwitchCollection {
  public selectInitialData() {
    // if (this.countSelectedItem() > 1) {
    //   this.itemSelect(this.getSelectedId(), true);
    // }

    this.selectAllIfNeeded();
  }

  public selectFirstAvailable() {
    if (!this.hasSelected()) {
      const first = this.items.find((item) => !item.disabled && !this.itemIsAll(item));

      if (first) {
        this.makeItemSelect(first, true);
      }
    }
  }

  public getSelectedItem(): SwitchItem {
    return this.items.find((item) => item.selected && !item.disabled && !this.itemIsAll(item));
  }

  public getSelectedId(): (string | number) {
    return this.getSelectedItem()?.id;
  }

  public hasSelected(): boolean {
    return !!this.getSelectedItem();
  }

  public getItemById(id: number | string) {
    return this.getById(id);
  }

  public itemSelect(id: number | string, selected: boolean = null, deSelectOthers = false) {
    const item = this.getItemById(id);
    this.makeItemSelect(item);
  }

  public makeItemSelect(item: SwitchItem, selected: boolean = null, ignoreEvent = false, deSelectOthers = false) {
    if (!item.disabled) {
      const before = this.getSelectedId();

      if (this.allItem) {

        if (this.itemIsAll(item)) {
          if (this.allItem.selected) {

          } else {
            this.setSelected(item, true);
          }
        } else {
          if (item.selected && selected === null) {
            this.setSelected(this.allItem, true);
          } else {
            this.setSelected(item, true);
          }
        }

      } else {
        if (!item.selected) {
          this.setSelected(item, true);
        }
      }

      if (!ignoreEvent && before !== this.getSelectedId()?.toString()) {
        this.callOnChange();
      }
    }
  }

  public setSelected(item: SwitchItem, selected: boolean) {
    // for radio set other to false only if current is se to true
    if (selected) {
      this.setSelectedAll(false, item.id, true);
    }

    item.selected = selected;
  }

  public setSelectedAll(selected: boolean, ignoreId: number | string = null, ignoreEvent = false) {
    const before = this.getSelectedId();

    if (!selected) {
      this.items.forEach((item) => {
        if (!!((typeof ignoreId !== 'undefined' && ignoreId !== null && item.id.toString() !== ignoreId.toString())) && !item.disabled) {
          this.setSelected(item, selected);
        }
      });
    }

    if (!ignoreEvent && before?.toString() !== this.getSelectedId()?.toString()) {
      this.callOnChange();
    }

  }

  public selectAllIfNeeded() {
    if (this.allItem) {
      this.allItem.selected = true;
    }
  }

  public getItemsForSelect(profileFix = false) {
    const item = this.getSelectedItem();

    if (item) {
      return profileFix ? {
        id: item.id,
        text: item.title,
      } : {
        id: item.id,
        title: item.title,
      };
    }

    return null;
  }

  public makeClone() {
    return new SwitchRadioCollection(this.items);
  }

  public deSelectAll() {
    this.setSelectedAll(false);
  }

  updateItems(items: SwitchItem[]) {
    this.items = plainToInstance(SwitchItem, items) as unknown as SwitchItem[];
    this.allItem = this.getById('all');
    this.selectInitialData();
  }
}

export class SwitchCheckboxCollection extends SwitchCollection {

  // тк для чекбокса метод getSelectedId не возвращает all, ставим его вручную если он выбран по умолчанию
  public selectInitialData() {
    if (this.allItem && this.allItem.selected) {
      this.itemSelect(this.allItem.id, true);
    }

    if (this.items.length) {
      this.items.forEach(item => {
        if (item.sub) {
          item.sub.unsubscribe();
        }

        if (item.subItems?.length) {
          item.subCollection = new SwitchCheckboxCollection(item.subItems);
          item.sub = item.subCollection.onChange.subscribe(() => this.setSelectedAndIndeterminate(item));

        }
      });
    }

    this.selectAllIfNeeded();
  }

  public setSelectedAndIndeterminate(item: SwitchItem) {
    const selected = (item.subCollection.getSelectedId(true) as any[]).length === item.subCollection.items.length;
    if (selected) {
      item.indeterminate = false;
    } else {
      item.indeterminate = !!this.getDescendants(item, true).find(child => child.selected);
      if (!item.selected) {
        this.callOnChange();
      }
    }
    this.makeItemSelect([item], selected, false, false, !selected);
  }

  public selectFirstAvailable() {
    if (!this.hasSelected()) {
      const first = this.items.find((item) => !item.disabled && !this.itemIsAll(item));

      if (first) {
        this.makeItemSelect([first], true);
      }
    }
  }

  public getSelectedItem(onlyFirstChild: boolean = false): SwitchItem[] {
    const selected: SwitchItem[] = [];
    this.items.forEach(item => {
      selected.push(...this.getSelectedItemsWithDescendants(item, onlyFirstChild));
    });
    return selected;
  }

  public getSelectedId(onlyFirstChild: boolean = false): (string | number)[] {
    return this.getSelectedItem(onlyFirstChild)?.map((item) => item.id);
  }

  public hasSelected(): boolean {
    return !!this.getSelectedItem()?.length;
  }

  public countSelectedItem(): number {
    return this.getSelectedItem().length;
  }

  public getItemById(id: ((number | string) | (number | string)[])) {
    return this.toArray(id)?.map((v) => this.getById(v)).filter((item) => !!item);
  }

  public itemSelect(id: ((number | string) | (number | string)[]), selected: boolean = null, deSelectOthers = false) {
    const items = this.getItemById(id);
    this.makeItemSelect(items, selected, false, deSelectOthers);
  }

  private makeItemSelect(items: SwitchItem[], selected: boolean = null, ignoreEvent = false, deSelectOthers = false, dontCheckChild: boolean = false) {
    const before = this.getSelectedId()?.toString();

    if (items) {
      if (deSelectOthers) {
        this.setSelectedAll(false, items.map((item) => item.id), true);
      }

      items.forEach((item) => {
        // @todo do something with disabled
        if (!item.disabled) {
          if (this.allItem) {
            if (this.itemIsAll(item)) {
              this.setSelectedAll(selected !== null ? selected : !item.selected, this.allItem.id, true);
            } else {
              this.setSelected(item, selected, dontCheckChild);
            }
          } else {
            this.setSelected(item, selected, dontCheckChild);
          }
        }
      });
    }

    if (!ignoreEvent && before !== this.getSelectedId()?.toString()) {
      this.callOnChange();
    }

    this.selectAllIfNeeded();
  }

  private setSelected(item: SwitchItem, selected: boolean = null, dontCheckChild: boolean = false) {
    item.selected = selected !== null ? selected : !item.selected;

    if (item.subCollection?.items?.length && !dontCheckChild) {
      const descendants = this.getDescendants(item, true);
      descendants.forEach(child => this.setSelected(child, item.selected));
      item.indeterminate = item.selected;
    }
  }

  public setSelectedAll(selected: boolean, ignoreId: ((number | string) | (number | string)[]) = null, ignoreEvent = false) {
    const items = [];
    this.items.forEach((item) => {
      const childs = this.getDescendants(item);
      childs.forEach(child => {
        if ((ignoreId === null || (ignoreId && !this.toArray(ignoreId).find(v => v.toString() === child.id.toString()))) && !this.itemIsAll(child) && !child.disabled) {
          items.push(child);
        }
      });
    });
    if (items.length) {
      this.makeItemSelect(items, selected, ignoreEvent);
    }
  }

  selectAllIfNeeded() {
    if (this.allItem) {
      this.allItem.selected = this.isAllSelected();
    }
  }

  public getItemsForSelect(profileFix = false) {
    const selected: SwitchItem[] = [];
    this.items.forEach(item => {
      selected.push(...this.getSelectedItemsWithDescendants(item));
    });
    return selected.map((item) => profileFix ? {
      id: item.id,
      text: item.title,
    } : {
      id: item.id,
      title: item.title,
    });
  }

  convertSelectModalData() {
    this.items.forEach(item => {
      let childSelected = false;
      item.visible = true;
      const descendants = this.getDescendants(item, true);
      descendants.forEach(descendant => {
        descendant.visible = true;
        if (item.selected || descendant.selected) {
          if (descendant.subItems?.length) {
            const subDescendants = this.getDescendants(descendant);
            subDescendants.forEach(subD => subD.selected = true);
          } else {
            descendant.selected = true;
          }
          childSelected = true;
        } else {
          if (descendant.subItems?.length) {
            const subDescendants = this.getDescendants(descendant);
            descendant.indeterminate = subDescendants.some(subD => subD.selected);
          }
        }
      });
      item.indeterminate = childSelected;
    });
  }

  getConvertedSubCollectionToSwitchItem(item?: SwitchItem): SwitchItem[] {
    const newItems: SwitchItem[] = [];

    const itemsList = item?.subCollection?.items?.length ? item.subCollection?.items : this.items;

    itemsList.forEach(itm => {
      itm.indeterminate = false;
      itm.visible = true;
      if (itm.subCollection?.items?.length) {
        const obj = {...itm, subItems: this.getConvertedSubCollectionToSwitchItem(itm)};
        obj.sub?.unsubscribe();
        obj.sub = null;
        newItems.push(obj);
      } else {
        newItems.push({...itm});
      }
    });
    if (!item) {
      this.items = newItems;
    }
    return newItems;
  }

  getDescendants(item: SwitchItem, withoutParent: boolean = false): SwitchItem[] {
    const descendants: SwitchItem[] = withoutParent ? [] : [item];
    if (item.subCollection?.items.length) {
      return descendants.concat(...item.subCollection.items.map(subItem => this.getDescendants(subItem)));
    }
    return descendants;
  }

  getSelectedItemsWithDescendants(item: SwitchItem, onlyFirstChild: boolean = false): SwitchItem[] {
    if (item.selected && !item.disabled && !this.itemIsAll(item)) {
      return [item];
    }

    const descendants: SwitchItem[] = [];
    if (item.subCollection?.items.length && !onlyFirstChild) {
      return descendants.concat(...item.subCollection.items.map(subItem => this.getSelectedItemsWithDescendants(subItem)));
    }
    return descendants;
  }

  public deSelectAll() {
    this.setSelectedAll(false);
  }

  public makeClone() {
    return new SwitchCheckboxCollection(this.items);
  }

  updateItems(items: any[]) {
    this.items = plainToInstance(SwitchItem, items) as unknown as SwitchItem[];
    this.allItem = this.getById('all');
    this.selectInitialData();
  }

  getByField(field: string, value: string | number): SwitchItem {
    let finded = null;
    this.items.forEach(item => {
      if (finded) {
        return;
      }
      const children = this.getDescendants(item);
      finded = children.find(child => (typeof child[field] !== 'undefined' && child[field] !== null) && child[field].toString() === value.toString());
    });
    return finded;
  }
}


